/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {AsideMenuItem} from './AsideMenuItem'
import AuthService from '../../../../app/modules/auth/redux/AuthService'

export function AsideMenuMain() {

  const usr = AuthService.GetCurrentUser()
  const checkAdmin = (user: any) => {
    if(user && user.userData && user.userData.roles) {
      if(user.userData.roles.includes('Ajans')) {
        return true
      } else {
        return false
      }
    }
  }
  const isAdmin = checkAdmin(usr)

  return (
    <>
      <div className='menu-item'>
        <div className='menu-content '>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Influencer</span>
        </div>
      </div>
      <AsideMenuItem
        to='/list' // dashboard
        icon='/media/icons/duotune/files/fil001.svg'
        title={'Influencer Listesi'}
        fontIcon='bi-app-indicator'
      />
      {isAdmin && <AsideMenuItem
        to='/sign-up' // builder
        icon='/media/icons/duotune/arrows/arr076.svg'
        title='Influencer Kayıt'
        fontIcon='bi-layers'
      />}
    </>
  )
}
